import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Checkbox } from "./ui/checkbox";

const LABELS = {
  "agenda.read": "See the calendar", "agenda.write": "Book & change appointments", "agenda.all": "See everyone's appointments (not only their own)",
  "clients.read": "See patients", "clients.write": "Add & edit patients", "clinical.write": "Clinical notes, forms & AI Scribe",
  "consents.read": "See signed consents", "consents.sign": "Collect consent signatures", "consents.write": "Edit consent templates",
  "messages.send": "Messages & inbox", "payments.read": "See revenue & invoices", "payments.write": "Take payments & make invoices",
  "payments.delete": "Delete payments", "reports.read": "See reports", "services.read": "See treatments", "services.write": "Manage treatments",
  "locations.read": "See locations", "locations.write": "Manage locations", "staff.read": "See the team", "staff.write": "Manage the team",
  "shop.read": "See the shop", "shop.write": "Manage shop products", "orders.write": "Handle shop orders", "content.write": "Reviews & blog",
  "settings.write": "Settings & marketing", "billing": "Billing & subscription",
};

export function StaffPermissions({ role, perms, onChange }) {
  const [cat, setCat] = useState(null);
  useEffect(() => { api.get("/staff/permissions").then((r) => setCat(r.data)).catch(() => {}); }, []);
  if (!cat) return null;
  if (role === "owner") return <p className="text-xs text-muted-foreground sm:col-span-2">Owners can always do everything.</p>;
  const active = new Set(perms ?? cat.defaults[role] ?? []);
  const toggle = (k) => {
    const next = new Set(active);
    next.has(k) ? next.delete(k) : next.add(k);
    onChange(cat.keys.filter((x) => next.has(x)));
  };
  return (
    <div className="sm:col-span-2 space-y-2" data-testid="staff-permissions">
      <div className="flex items-center justify-between">
        <p className="text-xs text-muted-foreground">What this person can do {perms ? "(customised)" : "(role defaults)"}</p>
        {perms && <button type="button" className="text-xs text-primary hover:underline" data-testid="staff-perms-reset" onClick={() => onChange(null)}>Reset to role defaults</button>}
      </div>
      <div className="grid sm:grid-cols-2 gap-x-4 gap-y-2 rounded-md border p-3">
        {cat.keys.map((k) => (
          <label key={k} className="flex items-center gap-2 text-sm"><Checkbox data-testid={`staff-perm-${k}`} checked={active.has(k)} onCheckedChange={() => toggle(k)} />{LABELS[k] || k}</label>
        ))}
      </div>
    </div>
  );
}
